// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-menu {
  position: fixed; /* Ensures it overlays the canvas */
  top: 0;
  left: 0;
  width: 250px; /* Width of the menu */
  height: 100vh;
  background-color: #2c2c2c; /* Dark gray background */
  color: "#3c3c3c"; /* Ensure text is visible */
  border-right: 1px solid #555;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
  padding: 1rem;
  transition: transform 0.3s ease-in-out;
}

.side-menu.collapsed {
  transform: translateX(-100%); /* Moves menu off-screen */
}

.menu-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.toggle-button {
  position: absolute;
  top: 0px;
  right: -56px;
  width: 60px;
  height: 60px;
  background: #d2d2d2;
  font-size: 34px;
  border: 0px;
  border-radius: 5px;
  cursor: copy;
  transition: background 0.3s;
}

.toggle-button:hover {
  background: #cecdcd;
  font-size: 38px;
}

/* Grid matrix styling */
.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px;
  margin-top: 0rem;
  padding: 10px 10px;
  position: relative;
}

/* Matrix brackets */
.grid-container::before,
.grid-container::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  width: 10px;
}

.grid-container::before {
  left: 0;
  border-left: 3px solid black;
  border-top: 3px solid black;
  border-bottom: 3px solid black;
  border-radius: 5px 0 0 5px;
}

.grid-container::after {
  right: 0;
  border-right: 3px solid black;
  border-top: 3px solid black;
  border-bottom: 3px solid black;
  border-radius: 0 5px 5px 0;
}

.grid-container input {
  padding: 2px 8px;
  font-size: 1rem;
  width: 20px;
  height: 20px;
  text-align: center;
  background-color: rgb(228, 228, 228); /* Light gray background */
  color: rgb(0, 0, 0); /* Black text */
  font-family: "Computer Modern", "Latin Modern Roman", serif; /* Computer Modern font */
  appearance: textfield;
  border: 2px solid green; /* Default border for left column */
  border-radius: 3px;
  line-height: 1; /* Ensures text is aligned properly */
}

/* Target inputs in the second column (right side) */
.grid-container input:nth-child(2n) {
  border: 2px solid rgb(190, 26, 26);
}

/* Remove number input arrows */
.grid-container input::-webkit-outer-spin-button,
.grid-container input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.grid-container input[type="number"] {
  -moz-appearance: textfield;
}

.add-vector-button {
  position: absolute;
  bottom: 50px;
  background-color: #325070; /* Blue color */
  color: white;
  font-size: 20px;
  font: "Computer Modern";
  border: none;
  border-radius: 8px;
  padding: 10px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-vector-button::before {
  content: "+";
  top: 10px;
  margin-right: 8px;
  font-size: 1.5rem;
}

/* .add-vector-button:hover {
  background-color: #146ece;
} */

.input-column {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
  margin-bottom: 16px;
}

.input-column label {
  font-size: 16px;
  white-space: nowrap;
  align-self: flex-start;
}

.input-column input {
  width: 50px;
  padding: 5px;
  text-align: center;
}

@media only screen and (max-width: 768px) {
  .grid-container {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }

  .grid-container input {
    font-size: 1.5rem;
    width: 40px;
    height: 40px;
  }

  .input-column input {
    font-size: 1.5rem;
    width: 60px;
    padding: 10px;
  }

  .add-vector-button {
    font-size: 1.8rem;
    bottom: 200px;
    padding: 14px;
  } 
} `, "",{"version":3,"sources":["webpack://./src/SideMenu.css"],"names":[],"mappings":"AAAA;EACE,eAAe,EAAE,mCAAmC;EACpD,MAAM;EACN,OAAO;EACP,YAAY,EAAE,sBAAsB;EACpC,aAAa;EACb,yBAAyB,EAAE,yBAAyB;EACpD,gBAAgB,EAAE,2BAA2B;EAC7C,4BAA4B;EAC5B,wCAAwC;EACxC,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,4BAA4B,EAAE,0BAA0B;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;EACP,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,QAAQ;EACR,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC,EAAE,0BAA0B;EAChE,mBAAmB,EAAE,eAAe;EACpC,2DAA2D,EAAE,yBAAyB;EACtF,qBAAqB;EACrB,uBAAuB,EAAE,mCAAmC;EAC5D,kBAAkB;EAClB,cAAc,EAAE,qCAAqC;AACvD;;AAEA,oDAAoD;AACpD;EACE,kCAAkC;AACpC;;AAEA,+BAA+B;AAC/B;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB,EAAE,eAAe;EAC1C,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,aAAa;EACf;AACF","sourcesContent":[".side-menu {\n  position: fixed; /* Ensures it overlays the canvas */\n  top: 0;\n  left: 0;\n  width: 250px; /* Width of the menu */\n  height: 100vh;\n  background-color: #2c2c2c; /* Dark gray background */\n  color: \"#3c3c3c\"; /* Ensure text is visible */\n  border-right: 1px solid #555;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);\n  padding: 1rem;\n  transition: transform 0.3s ease-in-out;\n}\n\n.side-menu.collapsed {\n  transform: translateX(-100%); /* Moves menu off-screen */\n}\n\n.menu-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.toggle-button {\n  position: absolute;\n  top: 0px;\n  right: -56px;\n  width: 60px;\n  height: 60px;\n  background: #d2d2d2;\n  font-size: 34px;\n  border: 0px;\n  border-radius: 5px;\n  cursor: copy;\n  transition: background 0.3s;\n}\n\n.toggle-button:hover {\n  background: #cecdcd;\n  font-size: 38px;\n}\n\n/* Grid matrix styling */\n.grid-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 5px;\n  margin-top: 0rem;\n  padding: 10px 10px;\n  position: relative;\n}\n\n/* Matrix brackets */\n.grid-container::before,\n.grid-container::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 10px;\n}\n\n.grid-container::before {\n  left: 0;\n  border-left: 3px solid black;\n  border-top: 3px solid black;\n  border-bottom: 3px solid black;\n  border-radius: 5px 0 0 5px;\n}\n\n.grid-container::after {\n  right: 0;\n  border-right: 3px solid black;\n  border-top: 3px solid black;\n  border-bottom: 3px solid black;\n  border-radius: 0 5px 5px 0;\n}\n\n.grid-container input {\n  padding: 2px 8px;\n  font-size: 1rem;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  background-color: rgb(228, 228, 228); /* Light gray background */\n  color: rgb(0, 0, 0); /* Black text */\n  font-family: \"Computer Modern\", \"Latin Modern Roman\", serif; /* Computer Modern font */\n  appearance: textfield;\n  border: 2px solid green; /* Default border for left column */\n  border-radius: 3px;\n  line-height: 1; /* Ensures text is aligned properly */\n}\n\n/* Target inputs in the second column (right side) */\n.grid-container input:nth-child(2n) {\n  border: 2px solid rgb(190, 26, 26);\n}\n\n/* Remove number input arrows */\n.grid-container input::-webkit-outer-spin-button,\n.grid-container input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.grid-container input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.add-vector-button {\n  position: absolute;\n  bottom: 50px;\n  background-color: #325070; /* Blue color */\n  color: white;\n  font-size: 20px;\n  font: \"Computer Modern\";\n  border: none;\n  border-radius: 8px;\n  padding: 10px 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.add-vector-button::before {\n  content: \"+\";\n  top: 10px;\n  margin-right: 8px;\n  font-size: 1.5rem;\n}\n\n/* .add-vector-button:hover {\n  background-color: #146ece;\n} */\n\n.input-column {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.input-column label {\n  font-size: 16px;\n  white-space: nowrap;\n  align-self: flex-start;\n}\n\n.input-column input {\n  width: 50px;\n  padding: 5px;\n  text-align: center;\n}\n\n@media only screen and (max-width: 768px) {\n  .grid-container {\n    grid-template-columns: 1fr 1fr;\n    gap: 10px;\n  }\n\n  .grid-container input {\n    font-size: 1.5rem;\n    width: 40px;\n    height: 40px;\n  }\n\n  .input-column input {\n    font-size: 1.5rem;\n    width: 60px;\n    padding: 10px;\n  }\n\n  .add-vector-button {\n    font-size: 1.8rem;\n    bottom: 200px;\n    padding: 14px;\n  } \n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
